module.exports = __webpack_public_path__ + "img/redness_5.3a1d37a5.png";